import { GeolocationDeniedTranslation } from '../../types/geolocationDenied.types';

export const geolocationDenied: GeolocationDeniedTranslation = {
  title: 'Geolocation blocked',
  firstParagraph:
    'Oops, it looks like you blocked access to your location! To continue, you need to allow us to know where you are.',
  secondParagraph: {
    part1: 'To enable your location, open the',
    siteSettings: 'Site settings',
    part2: ', by clicking the lock icon before the platform address. In the',
    permissions: 'Permissions',
    part3: 'section, set',
    location: 'Location',
    part4: 'to',
    allow: 'Allow',
  },
  retry: 'Try again',
};

export default geolocationDenied;
